import React from 'react';
import Rating from '@mui/material/Rating';

function PageCard() {
  const [value, setValue] = React.useState(3);

  return (
    <>
      <div className='bg-white shadow rounded-lg  w-full border-opacity-100 overflow-hidden border border-color-btn'>
        <div className='flex flex-row border-b p-4	border-color-grey '>
          <div className='text-xs text-black font-semibold'>
            Interessante Themen
          </div>
        </div>
        <div className='p-6'>
          <div className='flex flex-row6'>
            <img
              id='output'
              src='https://ui-avatars.com/api/?name=John+Doe'
              className='w-10 h-10 rounded-full object-cover'
              alt=''
            />
            <div className='text-xs font-semibold text-black m-2'>
              Bluthochdruck
            </div>
          </div>
          <div className='center-styl'>
            <Rating name='read-only' value={value} readOnly size='small' />
          </div>

          <div className='center-styl mt-4'>
            <button type='submit' className='btn2-styl'>
              Thema merken
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default PageCard;
